/* eslint-disable @typescript-eslint/no-use-before-define */
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import accountsManagement from 'services/accountManagement'
import {
  LostStolenCardAcceptedResponse,
  LostStolenCardRequest,
  LostStolenCardResponse
} from 'services/accountManagement/typings'
import { ServerError } from 'typings/serverError'

export interface LostStolenCardState {
  isLoading: boolean
  response: {
    paymentInstrumentLast4: string
    paymentInstrumentReferenceId: string
    acceptedMessage: string
  }
  error: ServerError
}

export const initState: LostStolenCardState = {
  isLoading: false,
  response: {
    paymentInstrumentLast4: '',
    paymentInstrumentReferenceId: '',
    acceptedMessage: ''
  },
  error: null
}

export const putLostStolenCard = createAsyncThunk(
  'lostCardSlice/putLostStolenCard',
  async (payload: LostStolenCardRequest, { dispatch }) => {
    dispatch(putLostCard())
    try {
      const response = await accountsManagement.putLostStolen(payload)

      if ('message' in response) {
        dispatch(putLostStolenCardAccepted(response))
      }

      if ('paymentInstrumentLast4' in response) {
        dispatch(putLostStolenCardFulfilled(response))
      }
    } catch (error) {
      dispatch(putLostStolenCardFailed(error))
    }
  }
)

export const lostCardSlice = createSlice({
  name: 'lostCardSlice',
  initialState: initState,
  reducers: {
    putLostCard: (state: LostStolenCardState) => {
      return {
        ...state,
        isLoading: true
      }
    },
    putLostStolenCardFulfilled: (
      state: LostStolenCardState,
      action: PayloadAction<LostStolenCardResponse>
    ) => {
      return {
        ...state,
        isLoading: false,
        response: {
          paymentInstrumentLast4: action.payload.paymentInstrumentLast4,
          paymentInstrumentReferenceId:
            action.payload.paymentInstrumentReferenceId,
          acceptedMessage: ''
        },
        error: null
      }
    },
    putLostStolenCardAccepted: (
      state: LostStolenCardState,
      action: PayloadAction<LostStolenCardAcceptedResponse>
    ) => {
      return {
        ...state,
        isLoading: false,
        response: {
          paymentInstrumentLast4: '',
          paymentInstrumentReferenceId: '',
          acceptedMessage: action.payload.message
        },
        error: null
      }
    },
    putLostStolenCardFailed: (
      state: LostStolenCardState,
      action: PayloadAction<LostStolenCardState>
    ) => {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      }
    }
  }
})

export const {
  putLostCard,
  putLostStolenCardFulfilled,
  putLostStolenCardAccepted,
  putLostStolenCardFailed
} = lostCardSlice.actions

export default lostCardSlice.reducer
